export const colors = {
  primaryBlue: "rgba(43, 207, 231, 1)",
  lightBlue: "rgba(224, 246, 250, 1)",
  primaryPurple: "rgba(85, 48, 193, 1)",
  lightPurple: "rgba(243, 231, 255, 1)",
  secondaryOrange: "rgba(246, 169, 3, 1)",
  inputFieldGrey: "rgba(247, 246, 248, 1)",
  delete: "rgba(246, 36, 36, 0.17)",
  dropdownGrey: "rgba(233, 236, 241, 1)",
  black: "rgb(0,0,0)",
  white: "rgba(256,256,256,256)",
};

export const promoDealCode = [
  {
    _id: "PRE_ORDER",
    name: "PRE ORDER",
  },
  // {
  //   _id: "APPOINTMENT",
  //   name: "APPOINTMENT",
  // },
];

export const teslaService = [
  {
    _id: true,
    name: "Yes",
  },
  {
    _id: false,
    name: "No",
  },
];

export const firebaseCredentials = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
